import React from 'react';
import Button from 'components/Button';
import styles from './filters.module.scss';

const Filters = ({ selectedTab }) => (
  <div className={styles.mediaFilters}>
    {/* Requested to be removed */}
    {/* <Button
      type={
        selectedTab === 'press' ? 'app-primary-button' : 'app-default-button'
      }
      linkAsButton={true}
      path="/press"
      state={{ internal: true }}
    >
      Press Releases
    </Button> */}
    {/* <Button
      type={
        selectedTab === 'news' ? 'app-primary-button' : 'app-default-button'
      }
      linkAsButton={true}
      path="/media"
      state={{ internal: true }}
    >
      In the News
    </Button> */}
  </div>
);

export default Filters;
